import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { get } from '../../services/http'

import { SliceStatus } from '../../interfaces/Redux';


export interface AppState {
  status: SliceStatus
  hasNotifications: number
  error?: string
}

const initialState: AppState = {
  status: SliceStatus.idle,
  hasNotifications: 0
}

export const notificationSlice = createSlice({
  name: 'branding',
  initialState,
  reducers: {
    reset: () => initialState,
    clearNotifications: () => initialState
  },
  extraReducers: (builder) => {
    builder
        .addCase(fetchNotifications.pending, (state) => {
            state.status = SliceStatus.loading;
            state.error = undefined;
        })
        .addCase(fetchNotifications.fulfilled, (state, action) => {
          if(action.payload || action.payload >= 0) {
              state.status = SliceStatus.idle;
              state.hasNotifications = action.payload;
              state.error = undefined;
          }
        })
        .addCase(fetchNotifications.rejected, (state, action) => {
            state.status = SliceStatus.failed
            state.error = action.error.message
        })
    }
  
})

export const fetchNotifications = createAsyncThunk('notifications/getNotifications', async (appGuid: string) => {
    const { data } = await get(`api/app/${appGuid}/notificationalerts/UnreadGroupCount`)
      .catch((response) => {
        throw new Error(response.message);
      })
        
    return data?.unreadGroupCount

    
});

export const { reset } = notificationSlice.actions

export default notificationSlice.reducer

export const { clearNotifications } = notificationSlice.actions
